import { useCallback } from "react";
import EVPorts from "./Components/EvPorts";
import { Breadcrumbs } from "~/components/UI";
import { useTranslation } from "react-i18next";

/**
 * @namespace EVPorts
 */

const EvPortsPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.catalogs") }, { label: t("title.evPorts") }];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <EVPorts />
    </>
  );
};

export default EvPortsPage;
